import { SUNSET_BM_ID, CARLS_JR_BM_ID } from '../tenants/BusinessModelMgr';
const generationMap = {
    [SUNSET_BM_ID]: 5,
};
export const DomainCoreGeneration = {
    Generation1: 1,
    Generation3: 3,
    Generation4: 4,
    Generation5: 5,
    detectObjectGeneration(x) {
        if (!x) {
            return DomainCoreGeneration.Generation1;
        }
        if (typeof x === 'object') {
            if (x && x[0] && x[0].generation && Number.isInteger(x[0].generation)) {
                return x[0].generation;
            }
            else {
                return DomainCoreGeneration.Generation1;
            }
        }
        else {
            return DomainCoreGeneration.Generation1;
        }
    },
    getGenerationByBMId: function (bmId) {
        if (generationMap[bmId])
            return generationMap[bmId];
        else
            return this.Generation1;
    },
};
export const demoTenantBusinessModels = {
    81: SUNSET_BM_ID,
    82: SUNSET_BM_ID,
    83: SUNSET_BM_ID,
    84: SUNSET_BM_ID,
    85: SUNSET_BM_ID,
    86: CARLS_JR_BM_ID,
    87: CARLS_JR_BM_ID,
    88: CARLS_JR_BM_ID,
    89: CARLS_JR_BM_ID,
    90: SUNSET_BM_ID,
    91: SUNSET_BM_ID,
    92: SUNSET_BM_ID,
    93: SUNSET_BM_ID,
    94: SUNSET_BM_ID,
    95: SUNSET_BM_ID,
    96: SUNSET_BM_ID,
    97: SUNSET_BM_ID,
    98: SUNSET_BM_ID,
    99: SUNSET_BM_ID,
    400: SUNSET_BM_ID,
    401: SUNSET_BM_ID,
    402: SUNSET_BM_ID,
    500: SUNSET_BM_ID,
    501: SUNSET_BM_ID,
    502: SUNSET_BM_ID,
};
export const oneClickTenantIdStart = 1000000;
